import React from 'react'
import { FormattedMessage } from 'react-intl'
import { isDisposableEmail } from 'disposable-email-domains-js'

export default function (values: any) {
  const errors: any = {}
  const requiredFields = [
    'name',
    'email',
    'phone',
    'acceptTerms',
    'country',
    'organization',
    ...(values.country === 'US' || !values.country ? ['state'] : [])
  ]

  requiredFields.forEach((field) => {
    if (
      !values[field] ||
      values[field] === 'none' ||
      (typeof values[field] === 'string' && values[field].trim() === '')
    ) {
      errors[field] = <FormattedMessage id='form.required' />
    }
  })

  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = <FormattedMessage id='form.invalid_email' />
  }

  if (values.email && isDisposableEmail(values.email)) {
    errors.email = <FormattedMessage id='form.forbidden_email_domain' />
  }

  return errors
}
